import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { PlataformaBadgeModule } from '../badge';

import { PlataformaOrigemBadgeComponent } from './plataforma-origem-badge.component';

@NgModule({
    imports: [
        SharedModule,
        PlataformaBadgeModule
    ],
    declarations: [
        PlataformaOrigemBadgeComponent
    ],
    exports: [
        PlataformaOrigemBadgeComponent
    ]
})
export class PlataformaOrigemBadgeModule { }
